import script from "./control-scale.vue?vue&type=script&setup=true&lang=ts"
export * from "./control-scale.vue?vue&type=script&setup=true&lang=ts"

import "./control-scale.vue?vue&type=style&index=0&id=66ffdd56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66ffdd56"]])

export default __exports__